import type { I18nFn } from '#/i18n/types/I18nFn';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { SEARCH_RADIUSES } from '#/utils/constants/general/searchRadiuses';

export function getSearchRadiusDescription(
  i18n: I18nFn,
  locale: I18nLocale,
  radius: number,
) {
  const milesText =
    /* TRANSLATORS: distance in miles */
    i18n('miles');

  const kmText =
    /* TRANSLATORS: abbreviation for kilometers */
    i18n('km');

  const radiusForLocale = SEARCH_RADIUSES[locale];
  const radiusOption = radiusForLocale[radius];

  if (radiusOption) {
    return radiusOption;
  }

  if (locale === I18nLocale.EN) {
    const miles = Math.round(radius / 1609.34);
    return `${miles} ${milesText}`;
  }

  const km = Math.round(radius / 1000);
  return `${km} ${kmText}`;
}
